import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { articles } from "@/data/blog";

const EASE = [0.22, 1, 0.36, 1];

export default function BlogTeaser({ t, lang }) {
    return (
        <section id="blog" data-testid="blog-teaser-section" className="relative mx-auto max-w-6xl px-5 sm:px-8 py-24">
            <div className="flex flex-wrap items-end justify-between gap-6">
                <div>
                    <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-glacier">{t.blog.overline}</p>
                    <h2 className="mt-4 font-display text-3xl sm:text-4xl font-medium tracking-tight text-ivory">
                        {t.blog.title}
                    </h2>
                </div>
                <a
                    href="/blog"
                    data-testid="blog-teaser-all-link"
                    className="inline-flex items-center gap-2 font-display text-xs font-semibold uppercase tracking-widest text-glacier transition-colors duration-300 hover:text-ivory"
                >
                    {t.blog.allArticles} <ArrowUpRight size={14} />
                </a>
            </div>
            <div className="mt-12 grid gap-6 md:grid-cols-3">
                {articles.map((a, i) => {
                    const c = a[lang] || a.sk;
                    return (
                        <motion.a
                            key={a.slug}
                            href={`/blog/${a.slug}`}
                            data-testid={`blog-teaser-card-${a.slug}`}
                            initial={{ opacity: 0, y: 28 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-60px" }}
                            transition={{ duration: 0.6, delay: i * 0.1, ease: EASE }}
                            className="group flex flex-col rounded-lg border border-white/10 bg-coal p-7 transition-[border-color,transform] duration-500 hover:border-glacier/40 hover:-translate-y-1"
                        >
                            <p className="font-mono text-[10px] uppercase tracking-[0.22em] text-fog">
                                {a.date} · {a.readMinutes} {t.blog.minRead}
                            </p>
                            <h3 className="mt-4 font-display text-lg font-medium leading-snug tracking-tight text-ivory">
                                {c.title}
                            </h3>
                            <p className="mt-3 flex-1 text-sm leading-relaxed text-fog">{c.excerpt}</p>
                            <span className="mt-6 inline-flex items-center gap-2 font-display text-xs font-semibold uppercase tracking-widest text-glacier transition-colors duration-300 group-hover:text-ivory">
                                {t.blog.readMore}
                                <ArrowUpRight size={14} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                            </span>
                        </motion.a>
                    );
                })}
            </div>
        </section>
    );
}
